import {API} from "@/middlewares/api";
import {createAsyncThunk} from "@reduxjs/toolkit";

export const loadBlogs = createAsyncThunk("blogs/loadBlogs", async ({pageNumber = 1} = {}, thunkAPI) => {
  try {
    const response = await API("secure/blogs", {
      method: "POST",
      body: {pageNumber},
    });

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const checkBlogs = createAsyncThunk("blogs/checkBlogs", async ({pageNumber = 1} = {}, thunkAPI) => {
  try {
    const response = await API("secure/blogs", {method: "POST", body: {pageNumber}});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const loadForYouBlogs = createAsyncThunk(
  "blogs/loadForYouBlogs",
  async ({pageNumber = 1, categoryIds = ""} = {}, thunkAPI) => {
    try {
      const response = await API("secure/blogs", {method: "POST", body: {pageNumber, categoryIds}});

      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const checkForYouBlogs = createAsyncThunk(
  "blogs/checkForYouBlogs",
  async ({pageNumber = 1, categoryIds = ""} = {}, thunkAPI) => {
    try {
      const response = await API("secure/blogs", {method: "POST", body: {pageNumber, categoryIds}});

      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const loadSavedPosts = createAsyncThunk("blogs/loadSavedPosts", async (_, thunkAPI) => {
  try {
    const response = await API("/secure/blogs/load-posts-saved");

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const loadBlogsCategories = createAsyncThunk("blogs/loadBlogsCategories", async (_, thunkAPI) => {
  try {
    const response = await API("secure/blogs/load-categories");

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const checkBlogsCategories = createAsyncThunk("blogs/checkBlogsCategories", async (_, thunkAPI) => {
  try {
    const response = await API("secure/blogs/load-categories");

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const savePost = createAsyncThunk("blogs/savePost", async ({postId}, thunkAPI) => {
  try {
    const response = await API("secure/blogs/save-post", {method: "POST", body: {postId}});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const searchPost = createAsyncThunk("blogs/searchPost", async (payload, thunkAPI) => {
  try {
    const response = await API("blogs/search-posts", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});
